// File: src/theme/colors.ts
// Define brand colors for the AZ1.AI website

const colors = {
  brand: {
    primary: {
      light: '#6BD495',
      base: '#57E675',  // Bright green from logo
      dark: '#0D615F',  // Dark teal/green from logo
    },
    secondary: {
      base: '#155453',  // Medium teal from logo
    },
  },
};

export default colors;